import ApiClient from './apiClient'
import { DedicatedServerPrice } from './bareMetalTypes'
import { Preorder, PreorderCreate, PreorderCreateOptions, PreorderListResponse, PreorderPriceParams } from './dedicatedPreorderTypes'

const url = 'dedicated-servers/preorders'
const preorderUrl = (id: string) => `${url}/${encodeURIComponent(id)}`

const dedicatedPreorderService = {
  getList: (params?: { page?: number; page_size?: number; ordering?: string; search?: string }) =>
    ApiClient.get<PreorderListResponse>(url, { params }),
  getById: (id: string) => ApiClient.get<Preorder>(preorderUrl(id)),
  create: (data: PreorderCreate) => ApiClient.post<Preorder>(url, data),
  cancel: (id: string) => ApiClient.post<Preorder>(`${preorderUrl(id)}/cancel`),
  getCreateOptions: () => ApiClient.get<PreorderCreateOptions>(`${url}/create-options`),
  getPrice: (params: PreorderPriceParams, signal?: AbortSignal) =>
    ApiClient.get<DedicatedServerPrice>(`${url}/get-price`, {
      params, signal, paramsSerializer: { indexes: null },
    }),
  // OpenAPI incorrectly describes permissions as a preorder; don't assume its shape.
  getPermissions: () => ApiClient.get<unknown>(`${url}/permissions`),
}

export default dedicatedPreorderService
